import React from 'react';
import { get, toWapi } from '../../util/api';
import _ from 'lodash';
import { CopyToClipboard } from 'react-copy-to-clipboard';
// eslint-disable-next-line
import styled from 'styled-components/macro';
import { Box, Button, Tab, Tabs, Table, TableBody, TableCell, TableHead, TableRow, TextField, TablePagination, Typography } from '@mui/material';
import DirectionsIcon from '@mui/icons-material/Directions';

const StatusBtn = (props) => {
	const [loading, setLoading] = React.useState(false);
	function onclick() {
		setLoading(true);
		props.onStatus().finally(() => setLoading(false));
	}

	return (
		<Button onClick={onclick} loading={loading} size="small">
			Status
		</Button>
	);
};

export default function Bawa() {
	const [loading, setLoading] = React.useState(true);
	const [data, setData] = React.useState({});
	const [subTab, setSubTab] = React.useState('bawa');
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(50);
	const [searchTerm, setSearchTerm] = React.useState('');

	React.useEffect(() => {
		get('/maytapi/admin/phoneList?type=bawa').then((temp) => {
			setLoading(false);
			const { phones, products } = temp;
			const map_pro = {},
				sub_pro = {};
			_.each(products, (it) => {
				map_pro[it.id] = it;
				if (it.sub)
					if (sub_pro[it.id]) sub_pro[it.id].push(it.sub);
					else sub_pro[it.id] = [it.sub];
			});
			setData({
				list: _.orderBy(
					_.map(
						_.filter(phones, (it) => it.type === 'whatsapp' && it.data && (it.data.bawa || it.data.basandbox)),
						(it) => {
							it.product = map_pro[it.pid];
							it.sub = sub_pro[it.pid];
							let token = (it.product && it.product.settings && it.product.settings.wapi_token) || temp.token;
							it.url = `https://api.maytapi.com/api/${it.pid}/${it.id}/screen?token=${token}`;
							it.token = token;
							it.copy_text = JSON.stringify(it, null, 2);
							return it;
						}
					),
					'id'
				),
			});
		});
	}, []);
	if (loading) return <Box attached="bottom">loading...</Box>;

	const { list } = data;

	async function getStatus(it) {
		const selected_index = _.findIndex(data.list, { id: it.id });
		await toWapi(`/api/${it.pid}/${it.id}/status`, it.token).then((result) => {
			const status_data = result && result.data;
			let updatedStatus = 'other';
			if (status_data && status_data.status) {
				if (status_data.status.connRetry) updatedStatus = 'no internet';
				else if (status_data.status.isQr) updatedStatus = 'qr-screen';
				else if (status_data.status.loading) updatedStatus = 'loading';
				else if (status_data.status.message) updatedStatus = 'phone-error';
				else if (status_data.status.loggedIn) updatedStatus = 'active';
			}
			const temp_list = [...data.list];
			temp_list[selected_index] = { ...temp_list[selected_index], new_status: 'new: ' + updatedStatus };
			setData({ ...data, list: temp_list });
		});
	}

	let filteredlist = _.filter(list, (it) => it.data && it.data[subTab]);

	if (searchTerm) {
		filteredlist = _.filter(filteredlist, (it) => {
			const searchableText = [it.id, it.pid, it.product?.email, it.status, it.number, it.auth, it.sessionId].join(' ').toLowerCase();
			return searchableText.includes(searchTerm.toLowerCase());
		});
	}

	const bawaCount = _.filter(list, (it) => it.data && it.data.bawa).length;
	const basandboxCount = _.filter(list, (it) => it.data && it.data.basandbox).length;

	const totalCount = filteredlist.length;
	const startIndex = page * rowsPerPage;
	const paginatedList = filteredlist.slice(startIndex, startIndex + rowsPerPage);

	const handleChangePage = (event, newPage) => setPage(newPage);
	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	return (
		<Box attached="bottom">
			<Tabs
				value={subTab}
				onChange={(e, v) => {
					setSubTab(v);
					setPage(0);
				}}
				sx={{ mb: 1 }}
			>
				<Tab value="bawa" label={`bawa (${bawaCount})`} />
				<Tab value="basandbox" label={`basandbox (${basandboxCount})`} />
			</Tabs>

			<Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
				{totalCount} phones
			</Typography>
			<div style={{ marginBottom: '20px' }}>
				<TextField
					placeholder="Search..."
					value={searchTerm}
					onChange={(e) => {
						setSearchTerm(e.target.value);
						setPage(0);
					}}
					style={{ width: '300px' }}
				/>
			</div>

			<Table celled>
				<TableHead>
					<TableRow>
						<TableCell textAlign="center" style={{ width: 70 }}>
							ID
						</TableCell>
						<TableCell>Product</TableCell>
						<TableCell>Status</TableCell>
						<TableCell>Number</TableCell>
						<TableCell></TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{_.map(paginatedList, (it) => {
						const { id, pid, product, number, auth, status, copy_text } = it;
						return (
							<TableRow key={id}>
								<TableCell textAlign="center">
									<CopyToClipboard text={copy_text}>
										<span>
											{id}
											<a href={it.url} target="_blank" rel="noopener noreferrer">
												<DirectionsIcon />
											</a>
										</span>
									</CopyToClipboard>
								</TableCell>
								<TableCell>
									{product ? (
										<a href={'/yta/logs?uid=' + product.uid} target="_blank" rel="noopener noreferrer">
											{product.email}
										</a>
									) : (
										pid
									)}
								</TableCell>
								<TableCell>
									{status}
									{it.sessionId ? ` [${it.sessionId}]` : ''}
									{it.new_status ? ` — ${it.new_status}` : ''}
								</TableCell>
								<TableCell>{(number || auth) && `${number}, ${auth}`}</TableCell>
								<TableCell>
									<StatusBtn onStatus={() => getStatus(it)} />
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>

			<TablePagination
				rowsPerPageOptions={[10, 25, 50, 100]}
				component="div"
				count={totalCount}
				rowsPerPage={rowsPerPage}
				page={page}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
			/>
		</Box>
	);
}
